import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { useDuplicateCartLineItems } from "../../../../../../hooks/hooks/use-duplicate-cart-line-items.js";
/* empty css                                */
const DuplicateLineItemContainer = ({ lineItem }) => {
  const { getLabel } = useIntl();
  const [duplicateToCart, { loading }] = useDuplicateCartLineItems(lineItem);
  const handleOnClick = React.useCallback(() => {
    duplicateToCart();
  }, [duplicateToCart]);
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      isLoading: loading,
      variant: "barebones",
      onClick: handleOnClick,
      size: "small",
      caption: getLabel("common.actions.duplicate"),
      className: "duplicate-line-item-action"
    }
  );
};
export {
  DuplicateLineItemContainer
};
//# sourceMappingURL=DuplicateLineItemContainer.js.map
